import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Button,
    Checkbox,
    Dropdown,
    Form,
    Header,
    Icon,
    Menu,
    Modal,
    Popup,
    Table,
} from 'semantic-ui-react';

import { clienteApi, Resultados } from 'src/api';
import { LinkAlumno, NombrePersonal } from 'src/componentes';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';
import { Contexto } from 'src/contexto';
import { nombreCompletoConNombresPrimero } from 'src/utilidades';

const styleMenuItem: React.CSSProperties = {
    paddingLeft: '5px',
};

type DatosDeContactoDeAlumno = Resultados<'datosDeContactoDeAlumnos'>[number];

type FiltroArea = 'preu' | 'ingles' | 'todas';
type FiltroPlan = 'anual' | 'intensivo' | 'intensivo-vespertino' | 'todos';
type FiltroAño = 2021 | 2020 | 2019;

const nombreDeFiltroArea: Record<FiltroArea, string> = {
    todas: 'Ambas áreas',
    preu: 'Solo preuniversitario',
    ingles: 'Solo inglés',
};
const nombreDeFiltroPlan: Record<FiltroPlan, string> = {
    'todos': 'Ambos planes',
    'anual': 'Solo anual',
    'intensivo': 'Solo intensivo',
    'intensivo-vespertino': 'Solo intensivo vespertino',
};
const nombreDeFiltroAño: Record<FiltroAño, string> = {
    2021: 'Año 2021',
    2020: 'Año 2020',
    2019: 'Año 2019',
};

type Columnas = Readonly<{
    correos: boolean;
    telefonos: boolean;
    planYArea: boolean;
}>;

type State = Readonly<{
    buscandoMatriculas: boolean;
    mostrandoModalDeCorreos: boolean;
    matriculas: ReadonlyArray<DatosDeContactoDeAlumno>;
    matriculasFiltradas: ReadonlyArray<DatosDeContactoDeAlumno>;
    filtroAño: FiltroAño;
    filtroArea: FiltroArea;
    filtroPlan: FiltroPlan;
    columnas: Columnas;
}>;

class DatosDeContacto extends React.Component<RouteComponentProps, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        buscandoMatriculas: false,
        mostrandoModalDeCorreos: false,
        matriculas: [],
        matriculasFiltradas: [],
        filtroAño: 2021,
        filtroArea: 'todas',
        filtroPlan: 'todos',
        columnas: {
            correos: true,
            telefonos: false,
            planYArea: false,
        },
    };

    public componentDidMount() {
        this.obtenerDatosDeContacto();
    }

    public render() {
        const { filtroAño, filtroArea, filtroPlan, matriculasFiltradas } = this.state;

        return (
            <>
                <Header as='h1'>Correos</Header>

                <Menu borderless size='large' attached='top' style={{ backgroundColor: '#f0f0ff' }}>
                    <Menu.Item fitted style={styleMenuItem}>
                        <Button
                            basic
                            icon='refresh'
                            loading={this.state.buscandoMatriculas}
                            disabled={this.state.buscandoMatriculas}
                            onClick={() => this.obtenerDatosDeContacto()}
                        />
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <Dropdown fitted='vertically' text={nombreDeFiltroAño[filtroAño]} item>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDeAño(2021)}
                                    content={nombreDeFiltroAño[2021]}
                                />
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDeAño(2020)}
                                    content={nombreDeFiltroAño[2020]}
                                />
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDeAño(2019)}
                                    content={nombreDeFiltroAño[2019]}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    <Menu.Item fitted style={styleMenuItem}>
                        <Dropdown fitted='vertically' text={nombreDeFiltroArea[filtroArea]} item>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDeArea('todas')}
                                    content={nombreDeFiltroArea.todas}
                                />
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDeArea('preu')}
                                    content={nombreDeFiltroArea.preu}
                                />
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDeArea('ingles')}
                                    content={nombreDeFiltroArea.ingles}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <Dropdown fitted='vertically' text={nombreDeFiltroPlan[filtroPlan]} item>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDePlan('todos')}
                                    content={nombreDeFiltroPlan.todos}
                                />
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDePlan('anual')}
                                    content={nombreDeFiltroPlan.anual}
                                />
                                <Dropdown.Item
                                    onClick={() => this.alCambiarFiltroDePlan('intensivo')}
                                    content={nombreDeFiltroPlan.intensivo}
                                />
                                <Dropdown.Item
                                    onClick={() =>
                                        this.alCambiarFiltroDePlan('intensivo-vespertino')
                                    }
                                    content={nombreDeFiltroPlan['intensivo-vespertino']}
                                />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <Popup
                            inverted
                            trigger={
                                <Button
                                    basic
                                    icon='mail outline'
                                    disabled={this.state.buscandoMatriculas}
                                    onClick={() => this.setState({ mostrandoModalDeCorreos: true })}
                                />
                            }
                            content='Mostrar correos'
                        />
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <Checkbox
                            label='Correos'
                            checked={this.state.columnas.correos}
                            onChange={(_, { checked }) => {
                                this.setState(ps => ({
                                    columnas: { ...ps.columnas, correos: !!checked },
                                }));
                            }}
                        />
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <Checkbox
                            label='Teléfonos'
                            checked={this.state.columnas.telefonos}
                            onChange={(_, { checked }) => {
                                this.setState(ps => ({
                                    columnas: { ...ps.columnas, telefonos: !!checked },
                                }));
                            }}
                        />
                    </Menu.Item>

                    <Menu.Item fitted style={styleMenuItem}>
                        <Checkbox
                            label='Plan y área'
                            checked={this.state.columnas.planYArea}
                            onChange={(_, { checked }) => {
                                this.setState(ps => ({
                                    columnas: { ...ps.columnas, planYArea: !!checked },
                                }));
                            }}
                        />
                    </Menu.Item>

                    <Menu.Item position='right'>{matriculasFiltradas.length} alumnos</Menu.Item>
                </Menu>

                {this.renderizarModalDeCorreos()}

                <Table id='tablaa' attached='bottom' celled compact fixed striped>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Alumno</Table.HeaderCell>

                            {this.state.columnas.correos && (
                                <Table.HeaderCell>Correo alumno</Table.HeaderCell>
                            )}

                            {this.state.columnas.telefonos && (
                                <Table.HeaderCell width={2}>Móvil alumno</Table.HeaderCell>
                            )}

                            {this.state.columnas.planYArea && (
                                <>
                                    <Table.HeaderCell width={1}>Área</Table.HeaderCell>
                                    <Table.HeaderCell width={1}>Plan</Table.HeaderCell>
                                </>
                            )}

                            <Table.HeaderCell>Apoderado</Table.HeaderCell>

                            {this.state.columnas.correos && (
                                <Table.HeaderCell>Correo apoderado</Table.HeaderCell>
                            )}

                            {this.state.columnas.telefonos && (
                                <Table.HeaderCell width={2}>Móvil apoderado</Table.HeaderCell>
                            )}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {matriculasFiltradas.map(matricula => (
                            <Fila
                                key={matricula.numeroDeContrato}
                                matricula={matricula}
                                columnas={this.state.columnas}
                            />
                        ))}
                    </Table.Body>
                </Table>
            </>
        );
    }

    private renderizarModalDeCorreos() {
        if (!this.state.mostrandoModalDeCorreos) return null;

        const { matriculasFiltradas, filtroArea, filtroPlan } = this.state;

        const correosAlumnos = new Array<string>(matriculasFiltradas.length);
        const correosApoderados = new Array<string>(matriculasFiltradas.length);
        for (let i = 0; i < matriculasFiltradas.length; i++) {
            const matricula = matriculasFiltradas[i];
            correosAlumnos[i] = matricula.correosAlumno[0];
            correosApoderados[i] = matricula.correosApoderado[0];
        }

        return (
            this.state.mostrandoModalDeCorreos && (
                <ModalCorreos
                    area={filtroArea}
                    plan={filtroPlan}
                    correosAlumnos={correosAlumnos}
                    correosApoderados={correosApoderados}
                    alCerrar={() => this.setState({ mostrandoModalDeCorreos: false })}
                />
            )
        );
    }

    private readonly alCambiarFiltroDeAño = (filtroAño: FiltroAño) => {
        this.setState({ filtroAño });
        this.obtenerDatosDeContacto(filtroAño);
    };

    private readonly alCambiarFiltroDeArea = (filtroArea: FiltroArea) => {
        this.setState({ filtroArea });
        this.filtrarFilas({ area: filtroArea });
    };

    private readonly alCambiarFiltroDePlan = (filtroPlan: FiltroPlan) => {
        this.setState({ filtroPlan });
        this.filtrarFilas({ plan: filtroPlan });
    };

    private readonly filtrarFilas = ({
        area = this.state.filtroArea,
        plan = this.state.filtroPlan,
    } = {}) => {
        const { matriculas } = this.state;

        const filtradas = matriculas.filter(
            mat => satisfaceFiltroArea(mat, area) && satisfaceFiltroPlan(mat, plan),
        );

        this.setState({ matriculasFiltradas: filtradas });
    };

    private readonly obtenerDatosDeContacto = (año = 2021) => {
        this.setState({ buscandoMatriculas: true });

        clienteApi
            .ejecutar('datosDeContactoDeAlumnos', { año })
            .then(resultados => {
                const matriculas = resultados.sort((a, b) =>
                    nombreCompletoConNombresPrimero(a.nombreAlumno).localeCompare(
                        nombreCompletoConNombresPrimero(b.nombreAlumno),
                    ),
                );
                this.setState(
                    {
                        buscandoMatriculas: false,
                        matriculas,
                    },
                    this.filtrarFilas,
                );
            })
            .catch(this.context.mostrarModalError);
    };
}

function satisfaceFiltroArea(fila: Readonly<DatosDeContactoDeAlumno>, filtro: FiltroArea) {
    if (filtro === 'todas') return true;
    return fila.area === filtro;
}

function satisfaceFiltroPlan(fila: Readonly<DatosDeContactoDeAlumno>, filtro: FiltroPlan) {
    if (filtro === 'todos') return true;
    return fila.plan === filtro;
}

const Fila = (props: { matricula: DatosDeContactoDeAlumno; columnas: Columnas }) => {
    const { matricula, columnas } = props;

    return (
        <Table.Row>
            <LinkAlumno
                numeroDeContrato={matricula.numeroDeContrato}
                nombre={{ nombre: matricula.nombreAlumno, patron: '%N %P %M' }}
                paraTabla
            />

            {columnas.correos && (
                <Table.Cell>
                    <CorreosPersonales correos={matricula.correosAlumno} />
                </Table.Cell>
            )}

            {columnas.telefonos && (
                <Table.Cell>
                    <Telefonos telefonos={matricula.telefonosAlumno} />
                </Table.Cell>
            )}

            {columnas.planYArea && (
                <>
                    <Table.Cell>{matricula.area === 'preu' ? 'Preu' : 'Inglés'}</Table.Cell>
                    <Table.Cell>
                        {matricula.plan === 'anual'
                            ? 'Anual'
                            : matricula.plan === 'intensivo'
                            ? 'Intensivo'
                            : 'Int. Vesp.'}
                    </Table.Cell>
                </>
            )}

            <Table.Cell>
                <NombrePersonal patron='%N %P %M' nombre={matricula.nombreApoderado} />
            </Table.Cell>

            {columnas.correos && (
                <Table.Cell>
                    <CorreosPersonales correos={matricula.correosApoderado} />
                </Table.Cell>
            )}

            {columnas.telefonos && (
                <Table.Cell>
                    <Telefonos telefonos={matricula.telefonosApoderado} />
                </Table.Cell>
            )}
        </Table.Row>
    );
};

const CorreosPersonales = (props: { correos: readonly string[] }) => {
    const { correos } = props;

    return <a href={'mailto:' + correos[0]}>{correos[0]}</a>;
};

const Telefonos = (props: { telefonos: DatosDeContactoDeAlumno['telefonosAlumno'] }) => {
    const { telefonos } = props;

    return <>9 {telefonos.movil.numero}</>;
};

export default DatosDeContacto;

type PropsModal = {
    area: FiltroArea;
    plan: FiltroPlan;
    correosAlumnos: readonly string[];
    correosApoderados: readonly string[];
    alCerrar(): void;
};

const ModalCorreos: React.FunctionComponent<PropsModal> = props => {
    const { alCerrar, correosAlumnos, correosApoderados, area, plan } = props;

    return (
        <ModalEnfocable open onClose={alCerrar} closeIcon>
            <Header>
                <Icon name='mail' />
                <Header.Content>Correos electrónicos</Header.Content>
            </Header>

            <Modal.Content>
                <Header as='h5'>
                    {nombreDeFiltroArea[area]} - {nombreDeFiltroPlan[plan]}
                </Header>

                <Form>
                    <Form.TextArea
                        label={`Alumnos (${correosAlumnos.length} correos)`}
                        rows='6'
                        autoFocus
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correosAlumnos.join(', ')}
                    />

                    <p>
                        Recuerde que algunos alumnos son sus propios apoderados. Sus correos pueden
                        estar en ambas listas.
                    </p>

                    <Form.TextArea
                        label={`Apoderados (${correosApoderados.length} correos)`}
                        rows='6'
                        readOnly
                        onFocus={(e: { target: { select(): void } }) => e.target.select()}
                        value={correosApoderados.join(', ')}
                    />
                </Form>

                <div style={{ marginTop: '14px' }}>
                    <p>
                        Puede copiar y pegar estos correos directamente en su sistema de correos
                        electrónicos.
                    </p>
                </div>
            </Modal.Content>
        </ModalEnfocable>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/DatosDeContacto/index.tsx